import { ids } from "@icarros/theme-react";
import { hexToRgba } from "@icarros/utils-react";
import styled, { css } from "styled-components";
import { Contrast } from "../../../types/general.types";
import { MenuButtonSizes, MenuButtonVariants, } from "./constants";
const { size, color, opacity } = ids || {};
const largeStyle = css `
  border-radius: ${size.corner_radius.ids_size_cornerRadius_card_01};
  padding: ${size.general.ids_size_general_10x};
  width: 152px;
  height: 152px;
`;
const mediumStyle = css `
  border-radius: ${size.corner_radius.ids_size_cornerRadius_card_02};
  padding: ${size.general.ids_size_general_8x};
  width: 100px;
  height: 100px;
`;
const fullStyle = css `
  border-radius: ${size.corner_radius.ids_size_cornerRadius_card_02};
  padding: ${size.general.ids_size_general_8x};
  width: 100%;
  height: 152px;
  ${({ useRatio, ratioHeight }) => {
    if (useRatio && ratioHeight)
        return `height: ${ratioHeight}px;`;
}}
`;
const primaryStyle = css `
  background: ${color.action.primary.ids_color_action_primary_base};
  border-color: ${color.action.primary.ids_color_action_primary_variant};

  &:hover,
  &:active {
    background: ${color.action.primary.ids_color_action_primary_variant};
  }

  ${({ isDisabled }) => {
    if (isDisabled)
        return `
      background: ${color.action.disabled.ids_color_action_disabled_base};
      border-color: ${color.action.disabled.ids_color_action_disabled_base};
      cursor: not-allowed;
    `;
}};
`;
const secondaryStyle = css `
  background: ${color.action.secondary.ids_color_action_secondary_base};
  border-color: ${color.action.secondary.ids_color_action_secondary_variant};

  &:hover,
  &:active {
    background: ${color.action.secondary.ids_color_action_secondary_variant};
  }

  ${({ isDisabled }) => {
    if (isDisabled)
        return `
      background: ${hexToRgba(color.action.disabled.ids_color_action_disabled_base, opacity.ids_opacity_empty)};
      border-color: ${color.action.disabled.ids_color_action_disabled_base};
      cursor: not-allowed;
    `;
}};
`;
const neutralStyle = css `
  background: ${color.contrast.ids_color_contrast_onDark};
  border-color: ${color.action.neutral.ids_color_action_neutral_base};

  &:hover,
  &:active {
    background: ${hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_medium)};
    border-color: ${color.action.neutral.ids_color_action_neutral_variant};
  }

  ${({ isDisabled }) => {
    if (isDisabled)
        return `
      background: ${hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_medium)};
      border-color: ${color.action.disabled.ids_color_action_disabled_variant};
      cursor: not-allowed;
    `;
}};
`;
const neutralOffStyle = css `
  background: ${hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_empty)};
  border-color: ${color.action.neutral.ids_color_action_neutral_base};

  &:hover,
  &:active {
    background: ${hexToRgba(color.action.neutral.ids_color_action_neutral_variant, opacity.ids_opacity_soft)};
    border-color: ${color.action.neutral.ids_color_action_neutral_variant};
  }

  ${({ isDisabled }) => {
    if (isDisabled)
        return `
      background: ${hexToRgba(color.action.disabled.ids_color_action_disabled_variant, opacity.ids_opacity_empty)};
      border-color: ${color.action.disabled.ids_color_action_disabled_variant};
      cursor: not-allowed;
    `;
}};
`;
const onDark = css `
  background: ${hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_empty)};
  border-color: ${color.contrast.ids_color_contrast_onDark};

  &:hover,
  &:active {
    background: ${hexToRgba(color.action.neutral.ids_color_action_neutral_variant, opacity.ids_opacity_strong)};
  }

  ${({ isDisabled }) => {
    if (isDisabled)
        return `
      cursor: not-allowed;
    `;
}};
`;
const onLight = css `
  background: ${hexToRgba(color.contrast.ids_color_contrast_onLight, opacity.ids_opacity_empty)};
  border-color: ${color.contrast.ids_color_contrast_onLight};

  &:hover,
  &:active {
    background: ${hexToRgba(color.action.neutral.ids_color_action_neutral_variant, opacity.ids_opacity_strong)};
  }

  ${({ isDisabled }) => {
    if (isDisabled)
        return `
      cursor: not-allowed;
    `;
}};
`;
const getMenuButtonVariantStyle = (variant, contrast) => {
    if (contrast === Contrast.dark)
        return onDark;
    if (contrast === Contrast.light)
        return onLight;
    switch (variant) {
        case MenuButtonVariants.primary: {
            return primaryStyle;
        }
        case MenuButtonVariants.secondary: {
            return secondaryStyle;
        }
        case MenuButtonVariants.neutral: {
            return neutralStyle;
        }
        case MenuButtonVariants.neutralOff: {
            return neutralOffStyle;
        }
        default:
            return primaryStyle;
    }
};
const getMenuButtonSizeStyle = (size) => {
    switch (size) {
        case MenuButtonSizes.medium: {
            return mediumStyle;
        }
        case MenuButtonSizes.large: {
            return largeStyle;
        }
        case MenuButtonSizes.full: {
            return fullStyle;
        }
        default:
            return mediumStyle;
    }
};
const StyledButton = styled.button `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;

  border-width: ${size.border_width.ids_size_border_small};
  border-style: solid;
  cursor: pointer;
  ${({ variant, contrast }) => getMenuButtonVariantStyle(variant, contrast)}
  ${({ size }) => getMenuButtonSizeStyle(size)}
`;
export default StyledButton;
//# sourceMappingURL=Menu.style.js.map